import { IExternalStorage } from '@kameleoon/javascript-sdk-core';

// --- Note ---
// Named `DataStorage` to avoid collision with `Storage` from `global` API
export class DataStorage<T> implements IExternalStorage<T> {
  private data: Map<string, T> = new Map();

  public read(key: string): T | null {
    return this.data.get(key) || null;
  }

  public write(key: string, data: T): void {
    this.data.set(key, data);
  }
}
